// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2do3B","content":"Header_content__1GT-W","touch":"Header_touch__1QFPE"};